import { render } from "./calculatorResultsComponent.vue?vue&type=template&id=772c8522"
import script from "./calculatorResultsComponent.vue?vue&type=script&lang=js"
export * from "./calculatorResultsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__